import { cleanQueryFromQuery } from "../common/functions/searches";
import {
  setFormConditions,
  appendCityCheckBoxes,
  changeMoneySelect,
  showCheckedItemName,
} from "../common/pages/search";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.pc.search_for_company.show").length) return;
  // 「/tokyo」⇒東京に初めからチェック、などを実行
  setFormConditions();
  // /shubuyaku のような「市区町村」のチェックボックスを後から挿入
  appendCityCheckBoxes();
  // アコーディオンの部分について、条件が設定されている場合は開いた状態にする。
  openSelectedConditionAccordions();
  // 連続でajaxのリクエストが実行された場合、直前のリクエストを中断
  let currentRequest;
  $("form#jsDetailSearch").on("ajax:beforeSend", (event, xhr, settings) => {
    if (currentRequest) currentRequest.abort();
    currentRequest = xhr;
    // 空のクエリは消す
    settings.url = cleanQueryFromQuery(settings.url);
  });
  $("form#jsDetailSearch").on("ajax:send", () => {
    $("#jsResultShower").hide();
    $("#jsLoading").fadeIn();
    // 検索結果通知メール登録ボタンの挙動
    $(".jsMailNotification").removeClass("isClicked");
  });
  // 費用での絞り込み時の挙動
  $(document).on("change", "#jsMoneySelect", () => {
    changeMoneySelect();
    $("form#jsDetailSearch").submit();
  });
  /// 活動日程変更時の検索駆動
  $(".datePicker").change(() => {
    $("form#jsDetailSearch").submit();
  });
  // チェック時にajaxのフォーム送信
  $(document).on("click", "#jsDetailSearch input:checkbox", function () {
    if ($(this).closest(".jsSearchCancel").length == 0) {
      $("form#jsDetailSearch").submit();
    }
  });
  // 選択されているエリアを表示
  const areaFirstCheckBox = $(".searchAreaBox").find("input:checkbox").first();
  showCheckedItemName(areaFirstCheckBox);
  // モーダルの検索ボタンクリック時の挙動
  $(document).on("click", ".jsModalSearch", function () {
    $("form#jsDetailSearch").submit();
    showCheckedItemName(this);
  });

  function openSelectedConditionAccordions() {
    const target_accordions = $("#jsDetailSearch .jsAccordion .jsContentWrap");
    const selected_accordions = target_accordions.filter(
      (i, accordion) =>
        $(accordion).find('input[type="checkbox"]:checked').length > 0
    );
    selected_accordions.each((i, accordion) => {
      $(accordion).prev().trigger("click");
    });
  }
});
